import { Link } from 'react-router-dom';
import { sidebarVariants } from './Sidebar.cva';

export interface SidebarProps {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
}

export function Sidebar({ className, isOpen, onClose }: SidebarProps) {
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      <div className={sidebarVariants({ isOpen, className })}>
        <div className="flex flex-col h-full">
          <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800">Menu</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 transition-colors"
              aria-label="Close menu"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <nav className="flex-1 p-6">
            <ul className="space-y-4">
              <li>
                <Link
                  to="/sample"
                  onClick={onClose}
                  className="block py-2 text-gray-700 hover:text-gray-900 transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/online-course"
                  onClick={onClose}
                  className="block py-2 text-gray-700 hover:text-gray-900 transition-colors"
                >
                  Online Course
                </Link>
              </li>
              <li>
                <Link
                  to="/schedule-appointment"
                  onClick={onClose}
                  className="block py-2 text-gray-700 hover:text-gray-900 transition-colors"
                >
                  Schedule a meeting
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
